// :cow: Cosmose CONFIDENTIAL :iso:
import { Action, createReducer, on } from '@ngrx/store';
import { getMediaGroupsListFailed, getMediaGroupsListRequested, getMediaGroupsListSucceeded } from './select-media-group.actions';

export const STATE_NAME_SELECT_MEDIA_GROUPS = 'select-media-groups';

export interface State {
  response?: string[];
  responseError: boolean;
  responseLoading: boolean;
}

const initialState: State = {
  response: undefined,
  responseError: false,
  responseLoading: false,
};

const reducer = createReducer(
  initialState,
  on(getMediaGroupsListRequested, (state) => (
    state.response != null
      ? state
      : {...state, responseLoading: true, responseError: false}
  )),
  on(getMediaGroupsListSucceeded, (state, {response}) => ({
    ...state,
    responseLoading: false,
    response,
    responseError: false,
  })),
  on(getMediaGroupsListFailed, (state) => ({...state, responseLoading: false, responseError: true})),
);

export function selectMediaGroupReducer(state: State | undefined, action: Action): any {
  return reducer(state, action);
}

